import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rule" }
const _hoisted_2 = { class: "rule-inner" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "page-rule",
    style: _normalizeStyle({'background-image': _ctx.activityData.templateConfig.homeBg ? 'url('+ _ctx.activityData.templateConfig.homeBg +')' : ''})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "rule-content",
          innerHTML: _ctx.activityData.templateConfig.desc
        }, null, 8, _hoisted_3)
      ])
    ])
  ], 4))
}